import React from 'react'
import { RouteComponentProps } from 'react-router'
import { Route, Switch } from 'react-router-dom'
import OrderCashier from './order-cashier/order-cashier'
import OrderMall from './order-mall/order-mall'

const path = '/main/order'

export const ORDER_CASHIER = path + '/orderCashier'
export const ORDER_MALL = path + '/orderMall'

export default (props: RouteComponentProps) => {
    return (
        <Switch>
            <Route path={props.match.path + '/orderCashier'} component={OrderCashier}></Route>
            <Route path={props.match.path + '/orderMall'} component={OrderMall}></Route>
        </Switch>
    )
}
